import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useComposerDelete, useComposerDetail } from "~/features/compoundRecordComposers/hooks";
import { toComposerDetailUI } from "~/features/compoundRecordComposers/utils/transformers";
import { CompoundRecordComposerDetailPresenter } from "./CompoundRecordComposerDetailPresenter";

interface CompoundRecordComposerDetailProps {
  id: string;
  onBack: () => void;
  variant?: "page" | "peek";
}

export function CompoundRecordComposerDetail({ id, onBack, variant = "page" }: CompoundRecordComposerDetailProps) {
  const { t } = useTranslation();
  const { data } = useComposerDetail(id);
  const { onDelete, processing } = useComposerDelete({ onSuccess: onBack });

  const raw = data.compoundRecordComposers[0];
  const composer = useMemo(() => (raw ? toComposerDetailUI(raw) : null), [raw]);

  if (!composer) {
    return <div className="mx-auto max-w-[var(--content-max)] p-8 text-14-regular text-fg-3">{t("ui.notFound")}</div>;
  }

  return (
    <CompoundRecordComposerDetailPresenter
      composer={composer}
      onBack={onBack}
      onDelete={() => void onDelete(composer.id)}
      processing={processing}
      variant={variant}
    />
  );
}
